import marquee from './marquee';

export default function newsMainSearch() {
    const container = document.querySelector('.js--news-main-search');
    if (!container) return;

    const button = container.querySelector('.news-search__icon');
    button.addEventListener('click', () => {
        container.classList.toggle('opened');
        marquee();
    });
}
